package xim.poc.game.configuration.v0.behaviors

import xim.poc.ActorId
import xim.poc.DefaultEnemyController
import xim.poc.game.ActorState
import xim.poc.game.ActorStateManager
import xim.poc.game.CombatBonusAggregate
import xim.poc.game.StatusEffect
import xim.poc.game.configuration.SkillApplier
import xim.poc.game.configuration.SkillApplierHelper
import xim.poc.game.configuration.SkillRangeInfo
import xim.poc.game.configuration.SkillSelection
import xim.poc.game.configuration.constants.*
import xim.poc.game.configuration.v0.V0MobSkillDefinitions.maxSourceRange
import xim.poc.game.configuration.v0.V0SpellDefinitions
import xim.poc.game.configuration.v0.constants.mobBlackConey
import xim.poc.game.configuration.v0.constants.mobWhiteConey
import xim.poc.game.event.Event

class MobWhiteConeyBehavior(actorState: ActorState): V0MonsterController(actorState) {

    override fun onInitialized(): List<Event> {
        val controller = actorState.movementController as? DefaultEnemyController ?: return emptyList()
        controller.followDistanceNear = 10f
        controller.followDistanceFar = 12f

        return emptyList()
    }

    override fun applyMonsterBehaviorBonuses(aggregate: CombatBonusAggregate) {
        aggregate.autoAttackScale *= 0.6f
        aggregate.movementSpeed += 50
        aggregate.fastCast -= 15
        aggregate.fullResist(StatusEffect.Sleep)
        if (getFriend() != null) { aggregate.regain += 50 }
    }

    override fun selectEngageTarget(): ActorId? {
        return super.selectEngageTarget() ?: getFriend()?.getTargetId()
    }

    override fun selectSkill(): SkillSelection {
        return SkillSelection(mskillWildCarrot_67, actorState)
    }

    override fun getSkillApplierOverride(skillId: SkillId): SkillApplier? {
        if (skillId != mskillWildCarrot_67) { return super.getSkillApplierOverride(skillId) }
        return SkillApplier(targetEvaluator = V0SpellDefinitions.sourcePercentageHealingMagic(15f))
    }

    override fun onSkillInterrupted(skill: SkillId): List<Event> {
        actorState.setTp(0)
        return emptyList()
    }

    override fun getSpells(): List<SkillId> {
        return listOf(spellBanishgaII_39)
    }

    override fun getSkillRangeOverride(skill: SkillId): SkillRangeInfo? {
        return if (skill == mskillWildCarrot_67) { maxSourceRange } else { super.getSkillRangeOverride(skill) }
    }

    private fun getFriend(): ActorState? {
        return ActorStateManager.filter { it.monsterId == mobBlackConey }.firstOrNull()
    }

}

class MobBlackConeyBehavior(actorState: ActorState): V0MonsterController(actorState) {

    private var hasUsedHundredFists = false

    override fun applyMonsterBehaviorBonuses(aggregate: CombatBonusAggregate) {
        aggregate.autoAttackScale *= 0.7f
        aggregate.movementSpeed += 50
    }

    override fun getSpells(): List<SkillId> {
        return listOf(spellStonegaII_190)
    }

    override fun wantsToCastSpell(): Boolean {
        return super.wantsToCastSpell() && !actorState.hasStatusEffect(StatusEffect.HundredFists)
    }

    override fun wantsToUseSkill(): Boolean {
        return wantsToUseHundredFists() || super.wantsToUseSkill()
    }

    override fun getSkills(): List<SkillId> {
        return super.getSkills() - mskillFootKick_1
    }

    override fun selectSkill(): SkillSelection? {
        return if (wantsToUseHundredFists()) { SkillSelection(mskillHundredFists_434, actorState) } else { super.selectSkill() }
    }

    override fun selectEngageTarget(): ActorId? {
        return super.selectEngageTarget() ?: getFriend()?.getTargetId()
    }

    override fun onSkillExecuted(primaryTargetContext: SkillApplierHelper.TargetEvaluatorContext): List<Event> {
        if (primaryTargetContext.skill == mskillHundredFists_434) { hasUsedHundredFists = true }
        return super.onSkillExecuted(primaryTargetContext)
    }

    private fun getFriend(): ActorState? {
        return ActorStateManager.filter { it.monsterId == mobWhiteConey }.firstOrNull()
    }

    private fun wantsToUseHundredFists(): Boolean {
        val friend = getFriend()
        return !hasUsedHundredFists && (friend == null || friend.isDead())
    }

}